import { baseUniDriverFactory } from '../../test-utils/utils/unidriver';
import { DataHooks } from './hooks';

export const headerUniDriverFactory = base => {
  const title = base.$(`[data-hook="${DataHooks.title}"]`);
  const subtitle = base.$(`[data-hook="${DataHooks.subtitle}"]`);

  return {
    ...baseUniDriverFactory(base),
    /** Returns title text */
    title: () => title.text(),
    /** Returns subtitle text */
    subtitle: () => subtitle.text(),
  };
};
